var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chat-message-area" } },
    [
      _vm.aiCopilot
        ? _c("AICopilot", {
            attrs: { payload: _vm.aiCopilot, contact: _vm.contact },
            on: {
              close: function ($event) {
                _vm.aiCopilot = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.visitorTypingMessage
        ? _c("VisitorTyping", { attrs: { message: _vm.visitorTypingMessage } })
        : _vm._e(),
      _vm._v(" "),
      _vm.repliedMessage()
        ? _c("ReplyMessage", {
            attrs: {
              message: _vm.repliedMessage(),
              "visitor-name": _vm.contact.fullname,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.mediaUploading.enabled
        ? _c("FileUploading", {
            attrs: { percentage: _vm.mediaUploading.percentage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("MessageArea", {
        ref: "messageArea",
        attrs: {
          contact: _vm.contact,
          messageSyncRunning: _vm.messageSyncRunning,
          messages: _vm.messages,
        },
        on: {
          message: function ($event) {
            return _vm.$emit("message", $event)
          },
          "media-message": function ($event) {
            return _vm.$emit("media-message", $event)
          },
          "ai-copilot": _vm.openAICopilot,
          "upload-file": function ($event) {
            return _vm.$emit("upload-file")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }